export interface IPassenger {
  firstName: string;
  lastName: string;
}

export const getPassengerName = (passenger: Partial<IPassenger>) => {
  return (passenger.firstName?.toLowerCase() ?? '') + (passenger.lastName?.toLowerCase() ?? '');
};
